<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-8 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! childHover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div class="wf-relative" :style="elementStyles(styles('styles'))" :class="elementClasses(classes('classes'), classes('customClasses'))">
      <div class="wf-h-full">
        <EditorComponentSection :key="selectedSection" :parentModule="parentModule"/>
      </div>
      <button
        v-show="content.hasButtons"
        @click.prevent="showPreviousSlide"
        class="wf-w-8 wf-h-8 wf-absolute focus:wf-outline-none wf-left-0 wf-my-auto wf-ml-2 wf-inset-y-0"
        :class="elementClasses(classes('buttonsClasses'))"
        :style="elementStyles(styles('buttonsStyles'))"
      >
        <i class="fas fa-chevron-left"></i>
      </button>
      <button
        v-show="content.hasButtons"
        @click.prevent="showNextSlide"
        class="wf-w-8 wf-h-8 wf-absolute focus:wf-outline-none wf-right-0 wf-my-auto wf-mr-2 wf-inset-y-0"
        :class="elementClasses(classes('buttonsClasses'))"
        :style="elementStyles(styles('buttonsStyles'))"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
      <nav
        v-show="content.hasDots"
        class="wf-absolute wf-bottom-0 wf-inset-x-0 wf-full wf-mb-5"
      >
        <ul class="wf-flex wf-full wf-items-center wf-justify-center">
          <li class="wf-mx-2" v-for="section in sections" :key="section.id">
            <button
              @click.prevent="selectedSection = section.id"
              :style="elementDotsStyles(section.id)"
              :class="elementClasses(classes('dotsClasses'))"
            ></button>
          </li>
          <li class="wf-mx-2" v-show="! previewMode">
            <button @click.prevent="addSlide()" class="wf-mt-1 wf-h-8 wf-bg-white wf-rounded-md wf-flex wf-items-center wf-justify-center wf-w-8">
              <i class="fas fa-plus wf-text-xs"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
  import {StylesParser} from '../StylesParser'
  import { TabFactory } from '../factories/TabFactory'
  import EditorComponentSection from './EditorComponentSection'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: {EditorComponentSection},
    data() {
      return {
        selectedSection: null,
      }
    },
    created() {
      this.selectedSection = this.sections[0].id
    },
    computed: {
      selectedSectionIndex() {
          return this.sections.findIndex(section => section.id == this.selectedSection)
      },
      sections: {
        get() {
          return this.$store.getters['componentSectionModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('componentSectionModule/updateOrder', {
            ...this.element,
            value
          })
        },
      },
    },
    methods: {
      addSlide(qty = 1) {
        let slides = (new TabFactory(qty)).create()
        this.addToArray(this.module, slides, 'sections', null, {}, true, this.parentModule)
      },
      elementDotsStyles(slide) {
        if(slide != this.selectedSection) {
          let styles = {...this.styles('dotsStyles')}
          Object.keys(styles).forEach(style => styles[style] = styles[style].filter(stylesStyle => stylesStyle.property == 'BorderColor'))
          return (new StylesParser(styles, this.device)).parse()
        }
        return {...(new StylesParser(this.styles('dotsStyles'), this.device)).parse(), ...(new StylesParser(this.styles('activeDotStyles'), this.device)).parse()}
      },
      showPreviousSlide() {
        if (! this.sections.length) {
          return
        }
        if(this.selectedSectionIndex == 0) {
          return this.selectedSection = this.sections[this.sections.length - 1].id
        }
        this.selectedSection = this.sections[this.selectedSectionIndex - 1].id
      },
      showNextSlide() {
        if (! this.sections.length) {
          return
        }
        if(this.selectedSectionIndex == (this.sections.length - 1)) {
          return this.selectedSection = this.sections[0].id
        }
        this.selectedSection = this.sections[this.selectedSectionIndex + 1].id
      }
    }
  })
</script>